import React from 'react';
import { TIPTAP_POLL_TYPE } from 'ricos-content';
import { PLUGIN_TOOLBAR_BUTTON_ID } from 'wix-rich-content-editor-common';
import { selectedNodeResolver } from 'wix-rich-content-plugin-commons';
import PollSettingsModal from './components/modals/SettingsModal.js';
import { TABS } from './components/settings/constants.js';
import { POLL_BUTTONS, pollModals } from './consts.js';
import { PollDesignButton } from './toolbar/PollDesignButton.js';
import { PollLayoutButton } from './toolbar/PollLayoutButton.js';
import PollLayoutPanel from './toolbar/PollLayoutPanel.js';
import 'ricos-context';
import './types.js';
import './components/settings/SettingsModal.js';
import 'classnames';
import 'prop-types';
import 'react-modal';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './viewer/poll-viewer.js';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import './components/rce-helpers-context/index.js';
import './viewer/poll-component.js';
import 'react-flip-move';
import 'react-measure';
import './style-inject.es-746bb8ed.js';
import './components/poll-option/index.js';
import './defaults-0542c304.js';
import 'wix-rich-content-common/libs/imageUtils';
import './components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import './RemoveOption-0fb59667.js';
import './assets/icons/RemoveIcon.js';
import './components/poll-option/PollOptionBase.js';
import './components/poll-option/types.js';
import './components/poll-context/types.js';
import './assets/icons/NonEditableIcon.js';
import './assets/icons/CheckIcon.js';
import './components/image-upload/ImageUpload.js';
import './components/image-upload/types.js';
import './assets/icons/LoaderIcon.js';
import './assets/icons/ReplaceIcon.js';
import './components/text-field/TextField.js';
import 'lodash';
import './components/poll-option/PollListOption.js';
import './components/poll-option/webview/PollListOptionWebview.js';
import './option-webview-c29b68a5.js';
import './components/poll-option/webview/PollGridOptionWebview.js';
import './components/poll-header/PollHeader.js';
import './components/poll-context/PollContext.js';
import './components/voted-users/VotedUsers.js';
import './components/voted-users/types.js';
import './VotedUsersModal-b3691022.js';
import 'react-infinite-scroller';
import './components/voted-users/VoterAvatar.js';
import './components/voted-users/FallbackAvatar.js';
import './assets/icons/AddIcon.js';
import './components/settings/edit-poll-section/EditPollSection.js';
import './components/settings/layout-settings-section/LayoutSettingsSection.js';
import './assets/icons/LayoutListIcon.js';
import './assets/icons/LayoutGridIcon.js';
import './components/settings/design-settings-section/DesignSettingsSection.js';
import './assets/icons/ColorIcon.js';
import './assets/icons/GradientIcon.js';
import './assets/icons/ImageIcon.js';
import './components/settings/poll-settings-section/PollSettingsSection.js';
import 'ricos-schema';
import 'wix-rich-content-toolbars-ui';
import './assets/icons/DesignIcon.js';
import './toolbar/PollButtonsData.js';
import './assets/icons/LayoutGridIconNew.js';
import './assets/icons/LayoutListIconNew.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getToolbarButtons = (config, services) => {
  const { modals } = services;
  return [
    {
      id: POLL_BUTTONS.layout,
      dataHook: "baseToolbarButton_layout",
      attributes: {
        selectedNode: selectedNodeResolver
      },
      modal: {
        Component: PollLayoutPanel,
        id: POLL_BUTTONS.layout
      },
      command: ({ value, editorCommands, attributes: { selectedNode } }) => {
        editorCommands.chain().focus().updateAttributes(TIPTAP_POLL_TYPE, {
          layout: {
            poll: __spreadProps(__spreadValues({}, selectedNode.attrs.layout.poll), { type: value })
          }
        }).run();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(PollLayoutButton, { toolbarItem, id: POLL_BUTTONS.layout, config })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: pollModals.design,
      dataHook: "baseToolbarButton_design",
      modal: {
        Component: PollSettingsModal,
        id: pollModals.design
      },
      command: ({ isMobile, attributes: { selectedNode } }) => {
        modals == null ? void 0 : modals.openModal(pollModals.settings, {
          componentProps: {
            nodeId: selectedNode.attrs.id,
            activeTab: TABS.DESIGN,
            settings: { showVoteRoleSetting: config == null ? void 0 : config.showVoteRoleSetting }
          },
          positioning: { placement: "right" },
          layout: isMobile ? "fullscreen" : "drawer"
        });
      },
      attributes: {
        selectedNode: selectedNodeResolver
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(PollDesignButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        Component: PollSettingsModal,
        id: pollModals.settings
      },
      command: ({ isMobile, attributes: { selectedNode } }) => {
        modals == null ? void 0 : modals.openModal(pollModals.settings, {
          componentProps: {
            nodeId: selectedNode.attrs.id,
            activeTab: TABS.SETTINGS,
            settings: { showVoteRoleSetting: config == null ? void 0 : config.showVoteRoleSetting }
          },
          positioning: { placement: "right" },
          layout: isMobile ? "fullscreen" : "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
